import { useEffect, useState } from "react";
 
export default function useGPC() {
  const [gpc, setGpc] = useState(() => {
    try {
      // Initial synchronous read if available
      return Boolean(typeof navigator !== "undefined" && navigator.globalPrivacyControl);
    } catch {
      return false;
    }
  });
 
  useEffect(() => {
    // Some extensions or future browsers may add this later.
    function check() {
      try {
        const value = Boolean(navigator?.globalPrivacyControl);
        setGpc(value);
      } catch {
        setGpc(false);
      }
    }
 
    check();
 
    // optional: poll a couple times shortly after load because some extensions set it late
    const t1 = setTimeout(check, 500);
    const t2 = setTimeout(check, 2000);
 
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);
 
  return gpc;
}
